export default "__VITE_ASSET__BVwuyEPM__"